export var ABOVE_LEFT_ANCHOR = {
  x: "left",
  y: "above"
};
export var ABOVE_INNER_LEFT_ANCHOR = {
  x: "inner-left",
  y: "above"
};
export var ABOVE_CENTER_ANCHOR = {
  x: "center",
  y: "above"
};
export var ABOVE_INNER_RIGHT_ANCHOR = {
  x: "inner-right",
  y: "above"
};
export var ABOVE_RIGHT_ANCHOR = {
  x: "right",
  y: "above"
};
export var TOP_LEFT_ANCHOR = {
  x: "left",
  y: "top"
};
export var TOP_INNER_LEFT_ANCHOR = {
  x: "inner-left",
  y: "top"
};
export var TOP_CENTER_ANCHOR = {
  x: "center",
  y: "top"
};
export var TOP_INNER_RIGHT_ANCHOR = {
  x: "inner-right",
  y: "top"
};
export var TOP_RIGHT_ANCHOR = {
  x: "right",
  y: "top"
};
export var CENTER_LEFT_ANCHOR = {
  x: "left",
  y: "center"
};
export var CENTER_INNER_LEFT_ANCHOR = {
  x: "inner-left",
  y: "center"
};
export var CENTER_CENTER_ANCHOR = {
  x: "center",
  y: "center"
};
export var CENTER_INNER_RIGHT_ANCHOR = {
  x: "inner-right",
  y: "center"
};
export var CENTER_RIGHT_ANCHOR = {
  x: "right",
  y: "center"
};
export var BOTTOM_LEFT_ANCHOR = {
  x: "left",
  y: "bottom"
};
export var BOTTOM_INNER_LEFT_ANCHOR = {
  x: "inner-left",
  y: "bottom"
};
export var BOTTOM_CENTER_ANCHOR = {
  x: "center",
  y: "bottom"
};
export var BOTTOM_INNER_RIGHT_ANCHOR = {
  x: "inner-right",
  y: "bottom"
};
export var BOTTOM_RIGHT_ANCHOR = {
  x: "right",
  y: "bottom"
};
export var BELOW_LEFT_ANCHOR = {
  x: "left",
  y: "below"
};
export var BELOW_INNER_LEFT_ANCHOR = {
  x: "inner-left",
  y: "below"
};
export var BELOW_CENTER_ANCHOR = {
  x: "center",
  y: "below"
};
export var BELOW_INNER_RIGHT_ANCHOR = {
  x: "inner-right",
  y: "below"
};
export var BELOW_RIGHT_ANCHOR = {
  x: "right",
  y: "below"
};